
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search-results/[idLocation]",
      function () {
        return require("private-next-pages/search-results/[idLocation].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search-results/[idLocation]"])
      });
    }
  